import { useMemo } from 'react';

import { config } from '@app/config';

import { getSalaryFrameHost } from '../utils/getSalaryFrameHost';

interface UseSalarySettingsTabParams {
  userId: number;
}

export const useSalarySettingsTab = ({
  userId,
}: UseSalarySettingsTabParams) => {
  const host = useMemo(
    () => getSalaryFrameHost(config.salaryHost, userId),
    [userId]
  );

  return { host };
};
